<template>
  <div id="app">
    <div class="container-fluid" >
      
      <!-- Header -->
      <div class="row w-100 justify-content-between align-items-center bg-white header" v-if="isLoggedIn">
        <router-link to="/"><h1 class="m-0 pl-3 font-weight-bold">E-Class</h1></router-link>
        <button type="button" class="border-0 bg-white font-weight-bold m-3" v-if="isLoggedIn" @click="logout">Log Out</button>
      </div>

      <div class="row main-content" v-if="isLoggedIn">
        <div class="col-12 d-inline-block">
          <button class="btn btn-primary d-md-none d-lg-none rounded-0 w-100 my-2" type="button" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
            Menu
          </button>
          <div class="collapse" id="collapseExample">
            <div class="p-0 bg-primary sidebar h-100">
                <div class="list-group m-3">
                  <!-- <router-link to="/video">
                    <h6 class="font-weight-bold text-white my-2">Video</h6>
                  </router-link>
                  <router-link to="/section">
                    <h6 class="font-weight-bold text-white my-2">Section</h6>
                  </router-link> -->
                  <router-link to="/course">
                    <h6 class="font-weight-bold text-white my-2">Course</h6>
                  </router-link>
                  <router-link to="/category">
                    <h6 class="font-weight-bold text-white my-2">Category</h6>
                  </router-link>
                  <router-link :to="{path: '/user', query:{page: 1, size: 10}}">
                    <h6 class="font-weight-bold text-white my-2">User</h6>
                  </router-link>
                  <router-link :to="{path: '/instructor', query:{page: 1, size: 10}}">
                    <h6 class="font-weight-bold text-white my-2">Instructor</h6>
                  </router-link>
                  <router-link to="/static">
                    <h6 class="font-weight-bold text-white my-2">Static</h6>
                  </router-link>
                </div>
              </div>
          </div>          
        </div>
        <!-- Sidebar -->


          <div class="d-none d-md-inline d-lg-inline col-12 col-md-2 col-lg-2 p-0 bg-primary sidebar h-100">
            <div class="list-group m-3">
              <!-- <router-link to="/video">
                <h5 class="font-weight-bold text-white my-2">Video</h5>
              </router-link>
              <router-link to="/section">
                <h5 class="font-weight-bold text-white my-2">Section</h5>
              </router-link> -->
              <router-link to="/course">
                <h5 class="font-weight-bold text-white my-2">Course</h5>
              </router-link>
              <router-link to="/category">
                <h5 class="font-weight-bold text-white my-2">Category</h5>
              </router-link>
              <router-link :to="{path: '/user', query:{page: 1, size: 10}}">
                <h5 class="font-weight-bold text-white my-2">User</h5>
              </router-link>
              <router-link :to="{path: '/instructor', query:{page: 1, size: 10}}">
                <h5 class="font-weight-bold text-white my-2">Instructor</h5>
              </router-link>
              <router-link to="/static">
                <h5 class="font-weight-bold text-white my-2">Static</h5>
              </router-link>
            </div>
          </div>
          

        <!-- Content -->
        <div class="col-md-10 offset-md-2 py-3">
          <router-view/>
        </div>
      </div>

      <div class="row" v-else>
        <div class="col-md-12">
          <router-view/>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  // const baseUrl = 'http://192.168.2.231:3000/v1/';
  // const baseUrl = 'http://192.168.2.120:3000/v1/';
  // const baseUrl = 'http://192.168.137.32:3000/v1/';
  // const baseUrl = 'https://eclass-does.herokuapp.com/v1/';
  const baseUrl = 'https://eclass.doesuniversity.com/v1/';

  export default {
    name: 'app',
    data() {
      return {
        isLoggedIn: false,

        url: {
          base: baseUrl,
          login: baseUrl + 'login',
          checktoken: baseUrl + 'checktoken',
          user: baseUrl + 'user',
          users: baseUrl + 'users',
          limitUser: baseUrl + 'userspage',
          category: baseUrl + 'category',
          categories: baseUrl + 'categories',
          limitInstructor: baseUrl + 'instructorspage',
          instructor: baseUrl + 'instructor',
          instructors: baseUrl + 'instructors',
          video: baseUrl + 'video',
          videos: baseUrl + 'videos',
          section: baseUrl + 'section/',
          sections: baseUrl + 'sections',
          course: baseUrl + 'course/',
          courses: baseUrl + 'courses',
          editcoursesections: baseUrl + 'editcourse/sections/',
          privacypolicy: baseUrl + 'privacypolicy',
          about: baseUrl + 'about',
          deactive: baseUrl + 'admindeactivateuser/',
          active: baseUrl + 'adminactivateuser/',
          uploadimage: baseUrl + 'uploadimage'
        },

        rolecode: {
          admin: 9,
          superadmin: 99
        }
      }
    },
    mounted(){
      if(localStorage.getItem('eclass-token')){
        this.isLoggedIn = true;

        // TODO: check tokennya punya admin beneran bukan
      }else{
        this.$router.push('/login');
      }

      this.$root.$on('isLoggedIn', ()=>{
        this.isLoggedIn = true;
        this.$router.push('/');
      });
    },
    methods: {
      clone(arr){
        return JSON.parse(JSON.stringify(arr));
      },
      getData(url, callback){
        axios.get(url).then(res => {
          if(res.status === 200){
            if(res.data.result){
              callback(res.data.result);
            }else{
              callback(res.data);
            }
          }else{
            callback(false);
          }
        })
        .catch(err => {
          console.log(err)
          callback(false)
        })
      },
      postData(url, data, callback){
        var headers = {
          'x-access-token': localStorage.getItem('eclass-token')
        }

        axios.post(baseUrl + 'checktoken' ,{}, {headers: headers}).then((res) => {
          if(res.status == 200){
            posted();
          }else {
            alert('Error')
          }
        }).catch(err=>{
          console.log(err)
        })

        function posted(){
          axios.post(url, data, {headers: headers}).then((res) => {
            console.log(res)
            console.log(res.data)
            alert('Success')
            window.location.reload();
          })
          .catch((err) => {
            alert('Error')
            console.log(err)
          })
          .then(() => {
            callback();
          })
        }
      },
      updateData(url, data, callback){
        axios.put(url, data).then((res) => {
          alert('Success')
          console.log(res)
          window.location.reload();
        })
        .catch((err) => {
          alert('Error')
          console.log(err)
        })
        .then(() => {
          callback();
        })
      },
      deleteData(url, callback){

        var tokens = localStorage.getItem('eclass-token');
        console.log('DELETE WITH TOKEN',tokens)
        
        var headers = {
          'x-access-token': localStorage.getItem('eclass-token'),
          'Content-Type': 'application/json'
        }

        axios.post(baseUrl + 'checktoken' ,{}, {headers: headers}).then((res) => {
          console.log(res)
          if(res.status == 200){
            deleted();
          }else{
            alert('Error');
          }
        }).catch(err=>{
          console.log(err)
        })

        function deleted(){
          axios.delete(url, {} ,{headers:headers}).then((res) => {
            alert('Success')
            console.log(res)
            window.location.reload();
          })
          .catch((err) => {
            alert('Error')
            console.log(err)
          })
          .then(() => {
            callback();
          })
        }
      },
      logout(){
        localStorage.removeItem('eclass-token');
        localStorage.removeItem('eclass-user');
        window.location.reload();
      }
    }
  }

</script>
<style>
  button {
    cursor: pointer;
  }
  .header {
    position: fixed;
    z-index: 9;
    height: 70px;
    top: 0;
  }
  div a:hover{
    text-decoration: none;
    list-style: none;
  }
  .main-content {
    margin-top: 70px;
  }

  @media (min-width: 768px) {

  /* Pull out the header and footer */
  .sidebar {
    position: fixed !important;
  }
}
</style>
